

// 주문 상세보기 레이어 열기
export function fn_scroll_up(target, type, rootStore) {
    if(type == "origin"){
        if(target.current.scrollTop <= 100){
            rootStore.layerStore.setScrollDisabled("up", true);
        }else{
            rootStore.layerStore.setScrollDisabled("up", false);
            rootStore.layerStore.setScrollDisabled("down", false);
        }   
    }
    target.current.scrollTo(0, target.current.scrollTop - 100);
}

// 주문 상세보기 레이어 열기
export function fn_scroll_down(target, type, rootStore) {
    if(type == "origin"){
        if(target.current.scrollTop >= 198){
            rootStore.layerStore.setScrollDisabled("down", true);
            rootStore.layerStore.setScrollDisabled("up", false);
        }else{
            rootStore.layerStore.setScrollDisabled("down", false);
            rootStore.layerStore.setScrollDisabled("up", false);
        }     
    }
    target.current.scrollTo(0, target.current.scrollTop + 100);
}

// select scroll up
export function fn_scroll_up_select(target) {
    target.current.scrollTo(0, target.current.scrollTop - 48);
}

// select scroll down
export function fn_scroll_down_select(target) {
    target.current.scrollTo(0, target.current.scrollTop + 48);
}

// select scroll Init
export function fn_scroll_Init_select(target) {
    target.current.scrollTo(0, 0);
}

